import { environment } from '@environment/environment';

export type CountryApiBase = 'api' | 'serviceCENAM';

const COUNTRY_STORAGE_KEY = 'country';

/**
 * Devuelve la URL base correspondiente al país guardado en localStorage
 * (seteado por las páginas de "load" a partir del query param que arma el back).
 * Si no hay país guardado, o el environment actual no tiene la variante para
 * ese país, cae de vuelta a la URL genérica (`environment[base]`).
 */
export function getCountryApiUrl(base: CountryApiBase): string {
  const country = localStorage.getItem(COUNTRY_STORAGE_KEY);
  const countryEnv = environment as unknown as Record<string, string>;
  const countryKey = country ? `${base}_${country}` : base;

  return countryEnv[countryKey] ?? countryEnv[base];
}
